import { useState } from "react";
import Nav from "./Nav";
import NavSidebar from "../Sidebar/NavSidebar";
import PropTypes from "prop-types";

export default function NavDashboard({
  // Finance-specific props
  selectedMonth,
  selectedCurrency,
  onMonthChange,
  onCurrencyChange,
  allCurrencies,
  authUserData
}) {
    const [sidebarToggled, setSidebarToggled] = useState(false);

    return (
        <>
            <Nav 
                setSidebarToggled={setSidebarToggled}
                selectedMonth={selectedMonth}
                selectedCurrency={selectedCurrency}
                onMonthChange={onMonthChange}
                onCurrencyChange={onCurrencyChange}
                allCurrencies={allCurrencies}
                authUserData={authUserData}
            />
            {sidebarToggled && <NavSidebar setSidebarToggled={setSidebarToggled} />}
            
        </>
    );
}

NavDashboard.propTypes = {
  // Finance-specific props
  selectedMonth: PropTypes.string,
  selectedCurrency: PropTypes.string,
  onMonthChange: PropTypes.func,
  onCurrencyChange: PropTypes.func,
  allCurrencies: PropTypes.array,
  authUserData: PropTypes.object,
};
